interface EarningsBreakdownProps {
  data: {
    client: string;
    earnings: number;
    hours: number;
    hourlyRate: number;
  }[];
}

export function EarningsBreakdown({ data }: EarningsBreakdownProps) {
  const totalEarnings = data.reduce((acc, item) => acc + item.earnings, 0);

  if (data.length === 0) {
    return (
      <div className="border border-border rounded-lg p-4">
        <h3 className="text-lg font-bold mb-4">Earnings by Client</h3>
        <div className="text-center py-8">
          <p className="text-muted-foreground">No earnings data available</p>
        </div>
      </div>
    );
  }

  return (
    <div className="border border-border rounded-lg p-4">
      <h3 className="text-lg font-bold mb-4">Earnings by Client</h3>
      <div className="space-y-4">
        {data.map((item, index) => {
          const percentage = totalEarnings > 0 ? (item.earnings / totalEarnings) * 100 : 0;

          return (
            <div key={index} className="space-y-2">
              <div className="flex items-center justify-between">
                <span className="font-medium text-foreground">{item.client}</span>
                <div className="text-right">
                  <span className="font-semibold text-foreground">
                    €{item.earnings.toLocaleString()}
                  </span>
                  <span className="text-sm text-muted-foreground ml-1">({item.hours}h)</span>
                </div>
              </div>
              <div className="w-full bg-muted rounded-full h-2">
                <div
                  className="h-2 rounded-full transition-all duration-300 bg-primary"
                  style={{ width: `${percentage}%` }}
                ></div>
              </div>
              <div className="text-xs text-muted-foreground text-right">{percentage.toFixed(1)}%</div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
